import { useLocalization } from '@/hooks/useLocalization';
import { Alert } from '../../../../../components/design-system';

export default function LocationAlerts() {
  const { alerts, deliveryMessages, azs } = useLocalization();

  const messages = [...deliveryMessages, ...alerts].map((m) => m.text);

  if (messages.length === 0) {
    return null;
  }

  return (
    <>
      {messages.map((message, index) => (
        <Alert
          key={message}
          className={index === messages.length - 1 ? 'mb-6' : 'mb-3'}
          dismissable
          status="warning"
        >
          {message}
        </Alert>
      ))}
    </>
  );
}
